// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrivacyConatiner {
  /* Add this CSS to your styles.css or a separate CSS file */
  /* Style for the data collection section */
  /* Media Query for responsiveness */
}
.PrivacyConatiner body, .PrivacyConatiner h1, .PrivacyConatiner h2, .PrivacyConatiner p, .PrivacyConatiner ul {
  margin: 0;
  padding: 0;
  color: black;
  line-height: 1.6;
  margin-bottom: 1rem;
  text-align: justify;
}
.PrivacyConatiner span {
  display: flex;
  justify-content: center;
  font-size: 20px;
}
.PrivacyConatiner ol {
  list-style-type: decimal;
  padding-left: 20px; /* Adjust as needed for indentation */
}
.PrivacyConatiner li {
  margin-bottom: 10px; /* Adjust as needed for spacing between items */
}
.PrivacyConatiner body {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  background-color: #f9f9f9;
  color: #333;
}
.PrivacyConatiner header {
  background-color: #6691ff;
  color: #fff;
  text-align: center;
  padding: 1rem 0;
}
.PrivacyConatiner header h1 {
  font-size: 2rem;
}
.PrivacyConatiner main {
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.PrivacyConatiner section {
  margin-bottom: 2rem;
}
.PrivacyConatiner h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
.PrivacyConatiner ul {
  list-style: disc;
  margin-left: 2rem;
}
.PrivacyConatiner a {
  color: #007bff;
  text-decoration: none;
}
.PrivacyConatiner #data-collection {
  margin-top: 20px;
  padding: 20px;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.PrivacyConatiner #data-collection h2 {
  font-size: 24px;
  color: #333;
}
.PrivacyConatiner #data-collection p {
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}
@media (max-width: 768px) {
  .PrivacyConatiner main {
    padding: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Privacy/privacypolicy.scss"],"names":[],"mappings":"AAAA;EAcI,2DAAA;EAwDA,0CAAA;EAqBA,mCAAA;AAvFJ;AAHI;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAKR;AAHI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AAKR;AAFI;EACI,wBAAA;EACA,kBAAA,EAAA,qCAAA;AAIR;AADI;EACI,mBAAA,EAAA,+CAAA;AAGR;AACI;EACI,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AACR;AAEI;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAGI;EACI,eAAA;AADR;AAII;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,wCAAA;EACA,kBAAA;AAFR;AAKI;EACI,mBAAA;AAHR;AAMI;EACI,iBAAA;EACA,mBAAA;AAJR;AAOI;EACI,gBAAA;EACA,iBAAA;AALR;AAQI;EACI,cAAA;EACA,qBAAA;AANR;AASI;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAPR;AAUI;EACI,eAAA;EACA,WAAA;AARR;AAWI;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AATR;AAcI;EACI;IACI,eAAA;EAZV;AACF","sourcesContent":[".PrivacyConatiner {\n    body, h1, h2, p, ul{\n        margin: 0;\n        padding: 0;\n        color: black;\n        line-height: 1.6;\n        margin-bottom: 1rem;\n        text-align: justify;\n    }\n    span{\n        display: flex;\n        justify-content: center;\n        font-size: 20px;\n    }\n    /* Add this CSS to your styles.css or a separate CSS file */\n    ol {\n        list-style-type: decimal;\n        padding-left: 20px; /* Adjust as needed for indentation */\n    }\n\n    li {\n        margin-bottom: 10px; /* Adjust as needed for spacing between items */\n    }\n\n\n    body {\n        font-family: Arial, sans-serif;\n        line-height: 1.6;\n        background-color: #f9f9f9;\n        color: #333;\n    }\n\n    header {\n        background-color: #6691ff;\n        color: #fff;\n        text-align: center;\n        padding: 1rem 0;\n    }\n\n    header h1 {\n        font-size: 2rem;\n    }\n\n    main {\n        max-width: 800px;\n        margin: 2rem auto;\n        padding: 1rem;\n        background-color: #fff;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        border-radius: 5px;\n    }\n\n    section {\n        margin-bottom: 2rem;\n    }\n\n    h2 {\n        font-size: 1.5rem;\n        margin-bottom: 1rem;\n    }\n\n    ul {\n        list-style: disc;\n        margin-left: 2rem;\n    }\n\n    a {\n        color: #007bff;\n        text-decoration: none;\n    }\n    /* Style for the data collection section */\n    #data-collection {\n        margin-top: 20px;\n        padding: 20px;\n        background-color: #f7f7f7;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n    }\n\n    #data-collection h2 {\n        font-size: 24px;\n        color: #333;\n    }\n\n    #data-collection p {\n        font-size: 16px;\n        color: #666;\n        margin-bottom: 10px;\n    }\n\n\n    /* Media Query for responsiveness */\n    @media (max-width: 768px) {\n        main {\n            padding: 0.5rem;\n        }\n    }\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
